/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: inline-block;
  line-height: 0;
}

.qds-form-message {
  color: var(--qds-theme-control-text-standard);
  display: inline-flex;
  gap: var(--qds-text-icon-gap);
}

.qds-icon-container,
.qds-icon-background {
  display: flex;
  align-items: center;
}

.qds-icon-background {
  border-radius: var(--qds-control-rounded-border-radius);
}

.qds-icon {
  color: var(--qds-theme-feedback-action-destructive-contrast);
}

.qds-sr-only {
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
}

[data-size='small'] {
  font: var(--qds-control-small-text);

  &.qds-icon-container {
    height: var(--qds-control-small-icon-crop-height);
  }

  &.qds-icon {
    width: var(--qds-control-small-icon-size);
    height: var(--qds-control-small-icon-size);
  }

  &.qds-inline {
    margin-block: var(--qds-control-small-padding-auto-height);
  }
}

[data-size='standard'] {
  font: var(--qds-control-standard-text);

  &.qds-icon-container {
    height: var(--qds-control-standard-icon-crop-height);
  }

  &.qds-icon {
    width: var(--qds-control-standard-icon-size);
    height: var(--qds-control-standard-icon-size);
  }

  &.qds-inline {
    margin-block: var(--qds-control-standard-padding-auto-height);
  }
}

[data-size='large'] {
  font: var(--qds-control-large-text);

  &.qds-icon-container {
    height: var(--qds-control-large-icon-crop-height);
  }

  &.qds-icon {
    width: var(--qds-control-large-icon-size);
    height: var(--qds-control-large-icon-size);
  }

  &.qds-inline {
    margin-block: var(--qds-control-large-padding-auto-height);
  }
}

[data-status='error'] {
  &.qds-icon-background {
    background-color: var(--qds-theme-feedback-result-failure);
  }

  &.qds-text {
    color: var(--qds-theme-feedback-result-failure);
  }
}

[data-status='info'].qds-icon-background {
  background-color: var(--qds-theme-feedback-message-informational);
}

[data-status='success'] {
  &.qds-icon-background {
    background-color: var(--qds-theme-feedback-result-success);
  }

  &.qds-text {
    color: var(--qds-theme-feedback-result-success);
  }
}

[data-status='warning'].qds-icon-background {
  background-color: var(--qds-theme-feedback-result-partial-success);
}
